<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/GKnJe7/tc-custom/9780300128673.jpg?1704825593205" alt="This image is the cover for the book Plausibility of Life"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Plausibility of Life
      </h1>
      <p class="bookDescription body article font2">
        <p><b>Two biologists tackle the unresolved question in the field of evolution: how have living organisms on Earth developed with such variety and complexity?</b></p><p>In the 150 years since Darwin, the field of evolutionary biology has left a glaring gap in understanding how animals developed their astounding variety and complexity. The standard answer has been that small genetic mutations accumulate over time to produce wondrous innovations such as eyes and wings. Drawing on cutting-edge research across the spectrum of modern biology, Marc Kirschner and John Gerhart demonstrate how this stock answer is woefully inadequate. Rather they offer an original solution to the longstanding puzzle of how small random genetic change can be converted into complex, useful innovations.<br/><br/> In a new theory they call “facilitated variation,” Kirschner and Gerhart elevate the individual organism from a passive target of natural selection to a central player in the 3-billion-year history of evolution. In clear, accessible language, the authors invite every reader to contemplate daring new ideas about evolution. By closing the major gap in Darwin’s theory Kirschner and Gerhart also provide a timely scientific rebuttal to modern critics of evolution who champion “intelligent design.”</p><p><b>“Makes for informative and enjoyable reading, and the issues the authors raise are worthy of attention.”—<i>American Scientist</i></b></p><p><b>“Thought-provoking and lucidly written…<i>The Plausibility of Life</i> will help readers understand not just the plausibility of evolution, but its remarkable, inventive powers.”—Sean Carroll, author of <i>Endless Forms Most Beautiful: The New Science of Evo Devo</i></b></p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Marc W. Kirschner, John C. Gerhart
      </h2>
      
      <p class="authorDescription body article">Marc W. Kirschner is professor and chair, Department of Systems Biology, Harvard Medical School. John C. Gerhart is professor in the Graduate School, University of California, Berkeley.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Yale University Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?f415238e